import createRoute       from '@widesk-ui/tools/createRoute';

export default createRoute.custom('Fiche mail', '/mails/:service/:id', 'MailDashboard');